'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.extractChildModelsRecursively = exports.extractChildModels = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _ramda = require('ramda');

var _immutable = require('../../immutable');

var _is_model = require('./is_model');

var extractReducer = function extractReducer(path, recursive) {
  return function (memo, _ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        attr = _ref2[1];

    return (
      // eslint-disable-next-line no-use-before-define
      (0, _ramda.concat)(memo, extract(attr, (0, _ramda.append)(key, path), recursive))
    );
  };
};

function extract(attribute, path, recursive) {
  if ((0, _is_model.isModel)(attribute)) {
    var model = attribute;

    if (recursive) {
      return (0, _ramda.reduce)(extractReducer(path, recursive), [[model, path]], (0, _ramda.toPairs)(model.props()));
    } else {
      return [[model, path]];
    }
  } else if ((0, _immutable.isImmutableType)(attribute)) {
    return attribute.reduce(function (memo, childAttribute, key) {
      return extractReducer(path, recursive)(memo, [key, childAttribute]);
    }, []);
  } else if ((0, _ramda.is)(Array, attribute)) {
    return (0, _ramda.reduce)(extractReducer(path, recursive), [], (0, _ramda.addIndex)(_ramda.map)(function (i, idx) {
      return [idx, i];
    }, attribute));
  } else if ((0, _ramda.is)(Object, attribute)) {
    return (0, _ramda.reduce)(extractReducer(path, recursive), [], (0, _ramda.toPairs)(attribute));
  } else {
    return [];
  }
}

var extractChildModels = exports.extractChildModels = (0, _ramda.pipe)((0, _ramda.invoker)(0, 'props'), _ramda.toPairs, (0, _ramda.reduce)(extractReducer([], false), []));

var extractChildModelsRecursively = exports.extractChildModelsRecursively = (0, _ramda.pipe)((0, _ramda.invoker)(0, 'props'), _ramda.toPairs, (0, _ramda.reduce)(extractReducer([], true), []));